/* ============================================================
   SHAMTAM welcome popup — production component (vanilla, no deps)
   Pairs with popup.css + mascot-art.{js,css} (mountElephant).

   ShamtamPopup.init({
     i18n,                // {lang:{...}} (or omit + i18nUrl to fetch)
     locale:'en',         // storefront locale; falls back to <html lang> then 'en'
     country:'GB',        // market country the page renders for (localization.country.iso_code)
     pageType:'product',  // request.page_type — stored on the profile for audit
     discount:'',         // retired 2026-10-23 (no percentage offers); the offer is the Rings balance
     privacyUrl:'/policies/privacy-policy',
     klaviyo:{ companyId:'RKvgMd', listId:'Rmxv8X' },  // public IDs (client API)
     delayDesktopMs:15000, delayMobileMs:8000,
     exitIntent:true, frequencyDays:14,
     demo:false,          // true = don't hit network, simulate success (prototype)
     force:false          // true = ignore frequency/subscribed guards (preview)
   })

   Single opt-in: submit -> Klaviyo client subscription (consent) -> success
   shows the Rings welcome balance (account sign-up); the welcome flow follows.
   No percentage code since 2026-10-23 (Alex): WELCOME10 is off, so is arm A.

   Language (T-EMAIL-FIX-LANG, 2026-09-28): the subscription carries the
   profile `locale` = storefront language + market country (it-IT, de-AT,
   en-NO: the same shape Shopify syncs for buyers). Klaviyo derives
   $locale_language from it, and the Welcome flow splits on that. Before this,
   no locale was sent and ~90% of popup sign-ups were filed as English.
   ============================================================ */
(function(window, document){
  var LS_DONE = 'shamtam_pop_sub';     // subscribed — never show again
  var LS_SNOOZE = 'shamtam_pop_snooze';// dismissed-until timestamp
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

  // 2-letter storefront language: 'pt-PT' -> 'pt'; Norwegian 'nb'/'nn' -> 'no' (the key
  // popup-i18n.json and the Klaviyo flow splits use).
  function langOf(s){ var l = String(s||'en').slice(0,2).toLowerCase(); return (l==='nb'||l==='nn') ? 'no' : l; }
  function now(){ return (new Date()).getTime(); }
  function lsGet(k){ try { return window.localStorage.getItem(k); } catch(e){ return null; } }
  function lsSet(k,v){ try { window.localStorage.setItem(k,v); } catch(e){} }

  var P = {
    cfg:null, t:null, host:null, mascot:null, mode:'desktop', lastFocus:null, shown:false,

    init:function(opts){
      opts = opts || {};
      var cfg = P.cfg = {
        i18n: opts.i18n || null,
        i18nUrl: opts.i18nUrl || 'popup-i18n.json',
        locale: langOf(opts.locale || document.documentElement.getAttribute('lang') || 'en'),
        country: String(opts.country || '').toUpperCase(),
        pageType: String(opts.pageType || ''),
        discount: opts.discount || '',
        discountUrl: opts.discountUrl || null,   // override the /discount/<code> auto-apply link
        privacyUrl: opts.privacyUrl || '/policies/privacy-policy',
        klaviyo: opts.klaviyo || {},
        mascotJsUrl: opts.mascotJs || null,     // lazy-loaded at open() — see ensureMascot
        mascotCssUrl: opts.mascotCss || null,
        delayDesktopMs: opts.delayDesktopMs!=null ? opts.delayDesktopMs : 30000,
        delayMobileMs: opts.delayMobileMs!=null ? opts.delayMobileMs : 20000,
        exitIntent: opts.exitIntent!==false,
        frequencyDays: opts.frequencyDays!=null ? opts.frequencyDays : 14,
        demo: !!opts.demo, force: !!opts.force, mode: opts.mode || null, noauto: !!opts.noauto,
        onOpen: opts.onOpen, onSubscribe: opts.onSubscribe,
        rings: opts.rings || null, signedIn: !!opts.signedIn
      };
      /* The pop-up offers the Rings balance and nothing else (Alex 2026-10-23: no percentage offers, WELCOME10 off).
         No pop-up for a signed-in visitor (already a member) or while Rings is off or its config cannot be read:
         the old fallback (arm A) handed out WELCOME10, a code that no longer works. */
      if ((!cfg.rings || !cfg.rings.on || cfg.signedIn) && !cfg.force) return P;
      var after = cfg.noauto ? (opts.ready || function(){}) : P.schedule;
      if (cfg.i18n) after(); else P.loadI18n(after);
      return P;
    },

    /* preview hook: open immediately in a chosen mode/locale (harness only) */
    previewOpen:function(mode, locale){
      if (P.host) P.close();
      P.shown = false; P.cfg.mode = mode; P.mode = mode; if (locale) P.cfg.locale = langOf(locale);
      setTimeout(P.open, 60);
    },

    loadI18n:function(done){
      try {
        fetch(P.cfg.i18nUrl).then(function(r){ return r.json(); })
          .then(function(j){ P.cfg.i18n = j; done(); })
          .catch(function(){ P.cfg.i18n = {}; done(); });
      } catch(e){ P.cfg.i18n = {}; done(); }
    },

    /* Rings A/B (T-RINGS): 'B' = account + balance offer; kept per browser */
    arm:function(){
      /* 'C' = the SHAMTAM Circle invitation (shop rings.config.circle = 'on', T-CLUB-THEME); otherwise the Rings offer
         (arm A, the WELCOME10 code, retired 2026-10-23; init never opens without Rings or the Circle) */
      return (P.cfg.rings && P.cfg.rings.circle) ? 'C' : 'B';
    },
    gt:function(key){ return P.t(key).replace('{gift}', (P.cfg.rings && P.cfg.rings.gift) || ''); },
    /* A "Join the Circle" link anywhere on the page opens the pop-up at once, ignoring the timer and the snooze. */
    join:function(){
      if (!P.cfg || !P.cfg.rings || !P.cfg.rings.circle || P.cfg.signedIn) return false;
      P.cfg.force = true;
      /* already signed up through the pop-up: no second form, the "you are in" panel says how it works (review 2026-10-26) */
      var inAlready = false; try { inAlready = !!localStorage.getItem(LS_DONE); } catch (e) {}
      var go = function(){ if (P.host) return; P.shown = false; P.mode = P.cfg.mode || (window.matchMedia('(max-width:760px)').matches ? 'mobile' : 'desktop'); P.open(); if (inAlready && P.host && P.arm() === 'C') P.showSuccessCircle(); };
      if (P.cfg.i18n) go(); else P.loadI18n(go);
      return true;
    },
    ringsAmount:function(){
      /* written by the theme's own money filter (same format as every price on the site) */
      var r = P.cfg.rings || {}; return r.label || ((r.amount || 0) / 100 + ' ' + (r.currency || ''));
    },
    rt:function(key){ return P.t(key).replace('{amount}', P.ringsAmount()); },

    t:function(key){
      var i = P.cfg.i18n || {};
      var dict = i[P.cfg.locale] || i['en'] || {};
      return dict[key] != null ? dict[key] : (i['en'] && i['en'][key]) || '';
    },

    eligible:function(){
      if (P.cfg.force) return true;
      if (lsGet(LS_DONE)) return false;                              // already subscribed
      var sn = parseInt(lsGet(LS_SNOOZE)||'0', 10);
      if (sn && now() < sn) return false;                            // within snooze window
      var path = (location.pathname||'').toLowerCase();
      if (/\/(checkout|cart|account|challenge|orders)\b/.test(path)) return false;
      if (/checkout\.shopify\.com/.test(location.hostname)) return false;
      return true;
    },

    schedule:function(){
      // preview/QA: ?stp=now forces an immediate open, ignoring delay + frequency + consent gate
      var qp; try { qp = new URLSearchParams(location.search); } catch(e){ qp = null; }
      if (qp && qp.get('stp') === 'now'){
        P.cfg.force = true;
        P.mode = P.cfg.mode || (window.matchMedia('(max-width:760px)').matches ? 'mobile' : 'desktop');
        P.open(); return;
      }
      if (!P.eligible()) return;
      P.mode = P.cfg.mode || (window.matchMedia('(max-width:760px)').matches ? 'mobile' : 'desktop');
      // Don't compete with the cookie-consent banner: wait until consent is resolved
      // (a choice made, or there is no banner) before arming the popup triggers, so the
      // two never stack on top of each other.
      P.whenConsentResolved(P.armTriggers);
    },

    consentResolved:function(){
      try { return !!(window.ShamtamConsent && window.ShamtamConsent.resolved); } catch(e){ return false; }
    },

    whenConsentResolved:function(cb){
      if (P.consentResolved()) return cb();
      var done = false;
      function go(){ if (done) return; done = true; document.removeEventListener('shamtam:consent-resolved', go); cb(); }
      document.addEventListener('shamtam:consent-resolved', go);
      // Fallback: if no consent banner is on screen (cookie.js absent, non-consent
      // region, or it never rendered) proceed after a few seconds; keep waiting while
      // the banner is still visibly demanding a choice.
      var tries = 0;
      (function poll(){
        if (done) return;
        if (P.consentResolved()) return go();
        var card = document.querySelector('#shamtam-cookie .ck-card');
        if (!card && tries >= 4) return go();
        tries++;
        if (tries <= 90) window.setTimeout(poll, 1000);
      })();
    },

    armTriggers:function(){
      if (P.shown) return;
      // settle: never pop the instant the visitor dismisses the cookie banner
      var SETTLE_MS = 3500, startedAt = now();
      function ready(){ return (now() - startedAt) >= SETTLE_MS; }
      var fired = false, fire = function(){ if (fired) return; fired = true; cleanup(); P.open(); };
      var delay = P.mode==='mobile' ? P.cfg.delayMobileMs : P.cfg.delayDesktopMs;
      var timer = window.setTimeout(fire, delay);                                   // idle ceiling
      function onExit(e){ if (e.clientY <= 0 && ready()) fire(); }                  // desktop: about to leave
      function onScroll(){ if (!ready()) return; var h=document.documentElement;
        if ((h.scrollTop||window.pageYOffset) > (h.clientHeight*0.5)) fire(); }     // engaged: read ~half a screen
      if (P.mode==='desktop' && P.cfg.exitIntent) document.addEventListener('mouseout', onExit);
      window.addEventListener('scroll', onScroll, {passive:true});                  // engagement on desktop + mobile
      function cleanup(){ window.clearTimeout(timer); document.removeEventListener('mouseout', onExit); window.removeEventListener('scroll', onScroll); }
    },

    open:function(){
      if (P.shown) return; P.shown = true;   // claim the slot immediately to prevent a double-open
      P.ensureMascot(P._open);
    },

    /* Lazy-load the elephant mascot (mascot-art.{js,css}) only when the popup is
       about to open — keeps ~10KB JS + its animation off every page. If it fails
       to load, install a no-op stub so the capture form still works; the mascot
       is decorative and must never block the email flow. */
    ensureMascot:function(cb){
      if (typeof window.mountElephant === 'function') return cb();
      var done = false;
      function go(){ if (done) return; done = true; cb(); }
      function stub(){ if (typeof window.mountElephant !== 'function') window.mountElephant = P._mascotStub; }
      try {
        if (P.cfg.mascotCssUrl && !document.querySelector('link[data-shamtam-mascot-css]')){
          var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = P.cfg.mascotCssUrl;
          l.setAttribute('data-shamtam-mascot-css',''); document.head.appendChild(l);
        }
        if (P.cfg.mascotJsUrl){
          var s = document.createElement('script'); s.src = P.cfg.mascotJsUrl; s.async = true;
          s.onload = go; s.onerror = function(){ stub(); go(); };
          document.head.appendChild(s);
          window.setTimeout(function(){ stub(); go(); }, 4000);   // safety: never hang the open
        } else { stub(); go(); }
      } catch(e){ stub(); go(); }
    },
    _mascotStub:function(){
      var noop = function(){};
      return { svg:{ classList:{ add:noop, remove:noop, toggle:noop } }, el:null, stickyDelight:false,
        enter:noop, bless:noop, celebrate:noop, reset:noop, wave:noop, toot:noop, shake:noop,
        perk:noop, setDelight:noop, lookAt:noop, pose:noop };
    },

    _open:function(){
      // impression metric for the email agent's conversion measurement (Klaviyo onsite JS)
      try {
        var ev = ['track', 'Welcome Popup Shown', { mode: P.mode, locale: P.cfg.locale }];
        if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(ev);
        else if (window._learnq && window._learnq.push) window._learnq.push(ev);
      } catch (e) {}
      P.lastFocus = document.activeElement;
      var host = P.host = document.createElement('div');
      host.id = 'shamtam-popup';
      host.innerHTML = P.mode==='mobile' ? P.sheetHTML() : P.modalHTML();
      document.body.appendChild(host);
      P.mascot = mountElephant(host.querySelector('.ele-host'));
      // wire
      host.querySelector('.stp-x') && host.querySelector('.stp-x').addEventListener('click', function(){ P.dismiss(); });
      var nope = host.querySelector('.stp-nope'); if (nope) nope.addEventListener('click', function(){ P.dismiss(); });
      host.querySelector('.stp-cta').addEventListener('click', P.submit);
      var field = host.querySelector('.stp-field');
      field.addEventListener('keydown', function(e){ if (e.key==='Enter'){ e.preventDefault(); P.submit(); } });
      field.addEventListener('input', function(){ field.classList.remove('stp-bad'); P.errEl().classList.remove('stp-show');
        var ok = EMAIL_RE.test(field.value||''); P.mascot.stickyDelight = ok; P.mascot.setDelight(ok);
        if (Math.random()<.3) P.mascot.perk(); });
      field.addEventListener('focus', function(){ P.mascot.lookAt(field); });
      field.addEventListener('blur', function(){ P.mascot.lookAt(null); });
      // a11y
      document.addEventListener('keydown', P.onKey);
      requestAnimationFrame(function(){ host.classList.add('stp-open'); P.mascot.enter(); setTimeout(function(){ field.focus(); }, 400); });
      if (P.cfg.onOpen) try { P.cfg.onOpen(); } catch(e){}
    },

    onKey:function(e){
      if (!P.host) return;
      if (e.key==='Escape'){ P.dismiss(); return; }
      if (e.key==='Tab'){ // focus trap
        var f = P.host.querySelectorAll('button,[href],input,[tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function(el){ return el.offsetParent!==null; });
        if (!f.length) return;
        var first=f[0], last=f[f.length-1];
        if (e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
    },

    errEl:function(){ return P.host.querySelector('.stp-err'); },

    submit:function(){
      var field = P.host.querySelector('.stp-field');
      var hp = P.host.querySelector('.stp-hp');
      if (hp && hp.value){ P.close(); return; }                 // honeypot tripped
      var email = (field.value||'').trim();
      if (!EMAIL_RE.test(email)){
        field.classList.add('stp-bad'); var er=P.errEl(); er.textContent=P.t('invalid'); er.classList.add('stp-show');
        field.focus(); P.mascot.shake();
        var m = P.host.querySelector('.stp-modal'); if (m){ m.classList.remove('stp-shake'); void m.offsetWidth; m.classList.add('stp-shake'); }
        return;
      }
      var cta = P.host.querySelector('.stp-cta'); cta.setAttribute('disabled','');
      P.subscribe(email).then(function(){
        lsSet(LS_DONE, '1');
        if (P.cfg.onSubscribe) try { P.cfg.onSubscribe(email); } catch(e){}
        P.mascot.celebrate();
        setTimeout(P.showSuccess, 650);
      }).catch(function(){
        cta.removeAttribute('disabled');
        var er=P.errEl(); er.textContent=P.t('invalid'); er.classList.add('stp-show'); // generic retry
      });
    },

    /* The profile locale Klaviyo derives $locale_language from: storefront
       language + market country ('it-IT', 'en-NO'); the bare language if the
       page gave no valid country; null if even the language is unusable. */
    profileLocale:function(){
      var l = P.cfg.locale, c = P.cfg.country;
      if (!/^[a-z]{2,3}$/.test(l)) return null;
      return /^[A-Z]{2}$/.test(c) ? l+'-'+c : l;
    },

    /* The exact request body subscribe() sends (kept separate so it can be read
       without sending anything). withLocale=false is the pre-2026-09-28 payload. */
    subscriptionBody:function(email, withLocale){
      var attrs = { email:email }, loc = P.profileLocale();
      if (withLocale !== false && loc){
        attrs.locale = loc;
        attrs.properties = { signup_locale:loc, signup_page_type:P.cfg.pageType||'unknown', signup_form:'welcome_popup', rings_arm:P.arm() };
        if (P.arm() === 'B') attrs.properties.rings_welcome = P.ringsAmount();
      }
      return { data:{ type:'subscription', attributes:{
        custom_source:'Welcome popup',
        profile:{ data:{ type:'profile', attributes:attrs } }
      }, relationships:{ list:{ data:{ type:'list', id:P.cfg.klaviyo.listId } } } } };
    },

    /* Klaviyo Client API — create subscription (public company_id; no secret) */
    subscribe:function(email){
      if (P.cfg.demo || !P.cfg.klaviyo.companyId) return Promise.resolve();
      // Klaviyo Client Subscriptions API: subscribing to the list IS the opt-in
      // (the list is single-opt-in). The `subscriptions`/consent object is for the
      // server-side bulk API only and 400s here ("not a valid field for profile").
      // `locale` + `properties` are profile attributes of revision 2024-10-15.
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(P.cfg.klaviyo.companyId);
      function send(withLocale){
        return fetch(url, {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'revision':'2024-10-15' },
          body: JSON.stringify(P.subscriptionBody(email, withLocale))
        });
      }
      var withLocale = !!P.profileLocale();
      return send(withLocale).then(function(r){
        // Never lose a sign-up over the language: if Klaviyo refuses the request (400),
        // send the old email-only payload once more.
        return (r.status === 400 && withLocale) ? send(false) : r;
      }).then(function(r){ if (!r.ok && r.status!==202) throw new Error('klaviyo '+r.status); });
    },

    showSuccess:function(){
      if (P.arm() === 'C') return P.showSuccessCircle();
      if (P.arm() === 'B') return P.showSuccessRings();
      var inner = P.host.querySelector('.stp-inner');
      // Auto-apply: Shopify /discount/<code> link activates the code in the cart
      // (works with the discount's own conditions); redirect keeps them where they were.
      var durl = P.cfg.discountUrl ||
        ('/discount/' + encodeURIComponent(P.cfg.discount) + '?redirect=' + encodeURIComponent(location.pathname || '/'));
      inner.innerHTML =
        '<p class="stp-kick" style="color:var(--stp-green)">'+esc(P.t('okKicker'))+'</p>'+
        '<h2 class="stp-h">'+esc(P.t('okTitle'))+' ✦</h2>'+
        '<button class="stp-code" type="button" aria-label="'+esc(P.t('okCopy'))+'"><span class="stp-code-ico" aria-hidden="true">⧉</span><span>'+esc(P.cfg.discount)+'</span></button>'+
        '<p class="stp-copy">'+esc(P.t('okCopy'))+'</p>'+
        '<p class="stp-sub">'+esc(P.t('okBody'))+'</p>'+
        '<a class="stp-cta" href="'+esc(durl)+'">'+esc(P.t('okCta'))+'</a>';
      inner.querySelector('.stp-code').addEventListener('click', P.copyCode);
      P.mascot.svg.classList.add('is-happy');
      inner.querySelector('.stp-cta').focus();
    },
    showSuccessCircle:function(){
      var inner = P.host.querySelector('.stp-inner');
      inner.innerHTML =
        '<p class="stp-kick" style="color:var(--stp-green)">'+esc(P.t('cOkKicker'))+'</p>'+
        '<h2 class="stp-h">'+esc(P.t('cOkTitle'))+'</h2>'+
        '<p class="stp-sub">'+esc(P.gt('cOkBody'))+'</p>'+
        '<button class="stp-cta" type="button">'+esc(P.t('cOkCta'))+'</button>';
      inner.querySelector('.stp-cta').addEventListener('click', function(){ P.close(); });
      P.mascot.svg.classList.add('is-happy');
      inner.querySelector('.stp-cta').focus();
    },
    showSuccessRings:function(){
      var inner = P.host.querySelector('.stp-inner');
      inner.innerHTML =
        '<p class="stp-kick" style="color:var(--stp-green)">'+esc(P.t('rOkKicker'))+'</p>'+
        '<h2 class="stp-h">'+esc(P.t('rOkTitle'))+'</h2>'+
        '<p class="stp-sub">'+esc(P.rt('rOkBody'))+'</p>'+
        '<a class="stp-cta" href="'+esc(P.cfg.rings.registerUrl || '/account/login')+'">'+esc(P.t('rOkCta'))+'</a>';
      P.mascot.svg.classList.add('is-happy');
      inner.querySelector('.stp-cta').focus();
    },
    copyCode:function(){
      var code = P.cfg.discount, hint = P.host && P.host.querySelector('.stp-copy');
      var done = function(){ if (!hint) return; hint.textContent = P.t('okCopied'); hint.classList.add('stp-copied');
        setTimeout(function(){ hint.textContent = P.t('okCopy'); hint.classList.remove('stp-copied'); }, 1800); };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText)
          navigator.clipboard.writeText(code).then(done, function(){ P.copyFallback(code, done); });
        else P.copyFallback(code, done);
      } catch (e) { P.copyFallback(code, done); }
    },
    copyFallback:function(code, done){
      try {
        var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly','');
        ta.style.position = 'fixed'; ta.style.left = '-9999px'; ta.style.top = '0';
        (P.host || document.body).appendChild(ta); ta.focus(); ta.select();
        try { ta.setSelectionRange(0, code.length); } catch (e) {}
        document.execCommand('copy'); ta.remove();
      } catch (e) {}
      done();
    },

    dismiss:function(){
      var until = now() + P.cfg.frequencyDays*86400000;
      lsSet(LS_SNOOZE, String(until));
      P.close();
    },
    close:function(){
      if (!P.host) return;
      document.removeEventListener('keydown', P.onKey);
      P.host.classList.remove('stp-open');
      var h = P.host; P.host = null;
      setTimeout(function(){ if (h && h.parentNode) h.parentNode.removeChild(h); }, 400);
      if (P.lastFocus && P.lastFocus.focus) try { P.lastFocus.focus(); } catch(e){}
    },

    bandHTML:function(){
      return '<div class="stp-band"><div class="stp-glow"></div>'+
        '<span class="stp-tw stp-tw1">✦</span><span class="stp-tw stp-tw2">✦</span><span class="stp-tw stp-tw3">✦</span>'+
        '<div class="ele-host"></div></div>';
    },
    formHTML:function(short){
      var consent = esc(P.t('consent')).replace(/SHAMTAM/, 'SHAMTAM');
      var privacy = '<a href="'+esc(P.cfg.privacyUrl)+'" target="_blank" rel="noopener">'+esc(P.t('privacy'))+'</a>';
      var field = '<input class="stp-field" type="email" inputmode="email" autocomplete="email" placeholder="'+esc(P.t('emailPh'))+'" aria-label="'+esc(P.t('emailPh'))+'"/>';
      var B = P.arm() === 'B';
      var cta = '<button class="stp-cta" type="button">'+(short?'→':esc(P.arm() === 'C' ? P.t('cCta') : B ? P.t('rCta') : P.t('cta')))+'</button>';
      var fieldBlock = short ? '<div class="stp-row">'+field+cta+'</div>' : field+cta;
      if (P.arm() === 'C') {
        var li = function(k, d){ return '<li><svg viewBox="0 0 24 24" aria-hidden="true">'+d+'</svg><span>'+esc(P.gt(k))+'</span></li>'; };
        return '<p class="stp-kick">'+esc(P.t('cKicker'))+'</p>'+
          '<h2 class="stp-h">'+esc(P.t('cTitle'))+'</h2>'+
          '<ul class="stp-benefits">'+
            li('cB1', '<path d="M12 3v18M7 8h7a3 3 0 0 1 0 6H8"/>')+
            li('cB2', '<path d="M12 4l2.4 4.8 5.3.8-3.8 3.7.9 5.3L12 16.1 7.2 18.6l.9-5.3L4.3 9.6l5.3-.8z"/>')+
            li('cB3', '<rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18"/>')+
            li('cB4', '<circle cx="12" cy="12" r="7"/><path d="M12 9v3l2 2"/>')+
          '</ul>'+
          '<input class="stp-hp" tabindex="-1" autocomplete="off" aria-hidden="true" placeholder=""/>'+
          fieldBlock+
          '<p class="stp-err" role="alert"></p>'+
          '<p class="stp-consent">'+esc(P.t('cFine'))+' '+consent+' '+privacy+'.</p>'+
          '<button class="stp-nope" type="button">'+esc(P.t(short ? 'dismissShort' : 'dismiss'))+'</button>';
      }
      return '<p class="stp-kick">'+esc(B ? P.t('rKicker') : P.t('kicker'))+'</p>'+
        '<h2 class="stp-h">'+esc(B ? P.rt('rTitle') : (short?P.t('titleMobile'):P.t('titleDesktop')))+'</h2>'+
        '<p class="stp-sub">'+esc(B ? P.rt('rSub') : P.t('sub'))+'</p>'+
        '<input class="stp-hp" tabindex="-1" autocomplete="off" aria-hidden="true" placeholder=""/>'+
        fieldBlock+
        '<p class="stp-err" role="alert"></p>'+
        '<p class="stp-consent">'+(B ? esc(P.t('rFine'))+' ' : '')+consent+' '+privacy+'.</p>'+
        (short ? '<button class="stp-nope" type="button">'+esc(P.t('dismissShort'))+'</button>'
               : '<button class="stp-nope" type="button">'+esc(P.t('dismiss'))+'</button>');
    },
    modalHTML:function(){
      return '<div class="stp-overlay"><div class="stp-modal" role="dialog" aria-modal="true" aria-label="'+esc(P.t('okKicker'))+'">'+
        '<button class="stp-x" type="button" aria-label="'+esc(P.t('close'))+'">×</button>'+
        P.bandHTML()+'<div class="stp-inner">'+P.formHTML(false)+'</div></div></div>';
    },
    sheetHTML:function(){
      return '<div class="stp-sheet" role="dialog" aria-modal="true" aria-label="'+esc(P.t('okKicker'))+'">'+
        '<button class="stp-x" type="button" aria-label="'+esc(P.t('close'))+'">×</button>'+
        P.bandHTML()+'<div class="stp-inner">'+P.formHTML(true)+'</div></div>';
    }
  };
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  window.ShamtamPopup = P;
  /* [data-circle-join] (header, product page, cart): open the Circle pop-up; where it cannot open, the link's own href */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('[data-circle-join]');
    if (a && P.join()) e.preventDefault();
  });
})(window, document);
